<template>
    <div class="languages-list" >

      <preloader class="language-combinatioin-preloader"  :preloader-status="filteredLanguages.length === 0" />

        <div class="search-row languages-list__search-row">
            <label>
                <span>Search on languages:</span>
                <input
                    class="search-row-languages"
                    type="text"
                    v-model="searchRowLanguage"
                    @keypress="languageFilter()"
                    @keyup="languageFilter()"
                />
            </label>

            <button @click="newLanguage = { ...initialNewLanguage }"  class="btn btn-blue"> Add new language </button>
        </div>

        <table class="default-table mg-bt52">
            <thead>
                <tr>
                    <td @click="toggleSortLanguages" class="minw250 languagesConfiguration__toggleSort" >
                        Language
                        <span class="sort-arrow" v-if="sortASC" > ↓ </span>
                        <span class="sort-arrow" v-if="!sortASC" > ↑ </span>
                    </td>

                    <td class="w150">Active</td>

                    <td class="w150">Deleted</td>

                    <td class="w250">Control</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="language in filteredLanguages" :key="language.ID">
                    <td class="minw250">
                        <span
                            v-bind:class="['language',language.CountryISOCode
                                ? language.CountryISOCode.toLowerCase()
                                : ''
                            ]"
                        ></span>
                        {{ language.LanguageName }}
                    </td>
                    <td>
                        <span :class="[ 'language-active', language.Active ? 'language-active--true' : 'language-active--false']" >
                             {{ language.Active ? 'active' : 'not-active' }}
                        </span>
                    </td>
                    <td>
                        <span :class="[ 'language-deleted', language.Deleted ? 'language-deleted--true' : 'language-deleted--false']" >
                             {{ language.Deleted ? 'deleted' : 'in use' }}
                        </span>
                    </td>
                    <td class="w250">
                        <div class="default-table__btn--wraper">
                            <button
                                class="btn-blue"
                                v-on:click="showLanguageEdition(language)"
                            >
                                Edit
                            </button>
                            <button v-if="!language.Deleted"
                                class="btn-red"
                                v-on:click="confirmRemoveLanguage(language.ID)"
                            >
                                Delete
                            </button>

                            <button
                              class="button btn default-table__btn "
                              v-if="language.Deleted"
                              v-on:click="restoreLanguage(language.ID)"
                               >
                                Restore
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <transition name="fade">
            <div class="modal-wrapper" v-if="confirmLanguage">
                <div @click="confirmLanguage = null" class="modal-backdrop"></div>
                <div class="modal-inner">
                    <button
                        class="close-modal edit-step-close"
                        @click="confirmLanguage = null"
                    >
                        <i class="fas fa-window-close"></i>
                    </button>
                    <div class="modal-steps-confirm">
                        <p>Remove this Language?</p>
                        <div class="modal-steps-confirm__choice">
                            <button @click="removeLanguage" class="btn btn-danger">
                                yes
                            </button>
                            <button
                                @click="confirmLanguage = null"
                                class="btn btn-neutral"
                            >
                                no
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div class="modal-wrapper" v-if="newLanguage">
                <div @click="newLanguage = null" class="modal-backdrop"></div>
                <div class="modal-inner">
                <button
                    class="close-modal edit-step-close"
                    @click="newLanguage = null"
                >
                    <i class="fas fa-window-close"></i>
                </button>

                <div>

                    <div>
                      <form  @submit.prevent="validate('create')" class="language-change-form">

                        <h2> Add new Language </h2>

                          <div class="language-change-form__grid">

                            <label class="language-change-form__grid--col1" for="Language Name"> Language Name </label>
                            <input name="language name" class="language-change-form__input" min="4" minlength="4" required v-model="newLanguage.LanguageName" type="text">

                            <label class="language-change-form__grid--col1" for="Country"> Country </label>
                            <div>
                              <input class="language-change-form__input"  name="Country" minlength="4"  required type="text" v-model="newLanguage.Country" />
                              <transition name="fade">
                                <div class="red color-red" v-if="invalidField === `create-country-length` "> country must be at least 4 charecters length </div>
                              </transition>
                            </div>

                            <label class="language-change-form__grid--col1" for="language status">
                                Status
                            </label>
                            <select @change="e => addChangeActive(e)" name="language status">
                              <option value="active"> active </option>
                              <option value="inactive"> inactive </option>
                            </select>

                            <label class="language-change-form__grid--col1" for="Country ISO code"> Country ISO code </label>
                            <input class="language-change-form__input"
                            name="Country ISO code"
                            required
                            type="text"
                            v-model="newLanguage.CountryISOCode"
                            />

                            <label class="language-change-form__grid--col1" for="Language ISO code"> Language ISO code </label>
                            <input class="language-change-form__input"
                            name="Language ISO code"
                            required
                            type="text"
                            v-model="newLanguage.LanguageISOCode"
                            />

                          <label class="language-change-form__grid--col1" for="ISO6392"> ISO6392 </label>
                          <div>
                            <input class="language-change-form__input"  name="ISO6392" minlength="3" maxlength="3" required type="text" v-model="newLanguage.ISO6392" />
                            <transition name="fade">
                              <div class="red color-red" v-if="invalidField === `create-ISO6392` "> ISO6392 must be 3 characters long </div>
                            </transition>
                          </div>

                        </div>

                        <div class="language-change-form__buttons" >
                          <button class="btn btn-blue" @click.prevent="validate('create')" type="submit"> Add </button>
                          <button  @click.prevent="newLanguage = initialNewLanguage" class="btn btn-red" > Clear </button>
                        </div>
                    </form>
                </div>

                </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div class="modal-wrapper" v-if="selectedLanguage">

                <div @click="selectedLanguage = null" class="modal-backdrop"></div>

                <div class="modal-inner">
                <button class="close-modal edit-step-close" v-on:click="selectedLanguage = null">
                    <i class="fas fa-window-close"></i>
                </button>
                <div>
                    <div>
                    <form @submit.prevent="editLanguage" class="language-change-form">

                        <h2> Edit Language </h2>

                        <div class="language-change-form__name" > <h3>{{ selectedLanguage.LanguageName }} </h3> </div>

                        <div class="language-change-form__grid">

                          <label class="language-change-form__grid--col1" for="Country"> Country </label>
                          <div>
                            <input class="language-change-form__input" name="Country"  minlength="4" required type="text" v-model="selectedLanguage.Country" />
                            <transition name="fade">
                            <div class="red color-red" v-if="invalidField === `edit-country-length` "> country must be at least 4 charecters length </div>
                            </transition>
                          </div>

                          <label class="language-change-form__grid--col1" for="Country ISO code"> Country ISO code </label>
                          <input
                            class="language-change-form__input"
                            name="Country ISO code"
                            required
                            type="text"
                            v-model="selectedLanguage.CountryISOCode"
                          />

                          <label class="language-change-form__grid--col1" for="language status">
                              Status
                          </label>

                          <select @change="e => editChangeActive(e)" name="language status">
                            <option value="active"> active </option>
                            <option value="inactive"> inactive </option>
                          </select>

                          <label class="language-change-form__grid--col1" for="Language ISO code"> Language ISO code </label>
                          <input
                            class="language-change-form__input"
                            name="Language ISO code"
                            required
                            type="text"
                            v-model="selectedLanguage.LanguageISOCode"
                          />

                          <label class="language-change-form__grid--col1" for="ISO6392"> ISO6392 </label>
                          <div>
                            <input class="language-change-form__input" name="ISO6392" minlength="3" maxlength="3" required type="text" v-model="selectedLanguage.ISO6392" />
                            <transition name="fade">
                              <div class="red color-red" v-if="invalidField === `edit-ISO6392` "> ISO6392 must be 3 characters long </div>
                            </transition>
                          </div>
                        </div>

                        <div class="language-change-form__buttons" >
                          <button class="btn btn-blue" @click.prevent="validate('edit')" type="submit"> Edit </button>
                          <button class="btn btn-red"> Clear </button>
                        </div>

                    </form>
                    </div>
                </div>
                </div>
            </div>
        </transition>

        <pagination
            v-model="pagination"
            :total="totalItems"
            :options="[6,12,24,36]"
        />

   </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import debounce from '@/utils/helpers/debounce';
import preloader from '@/components/preloader/index.vue';

const searchDebouncer = debounce();

export default Vue.extend({
  components: {
    pagination: () => import('@/components/paginationSimple/index.vue'),
    preloader,
  },
  data() {
    return {
      languages: [],
      selectedLanguage: null,
      searchRowLanguage: '',
      sortASC: true,
      filteredLanguages: [],
      invalidField: null,
      pagination: {
        page: 1,
        ppage: 12,
      },
      confirmLanguage: null,
      totalItems: 1,
      newLanguage: null,
      initialNewLanguage: {
        LanguageName: '',
        LanguageISOCode: '',
        Country: '',
        CountryISOCode: '',
        ISO6392: '',
        Active: false,
      },
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.getLanguages();
      },
    },
  },
  methods: {
    addChangeActive(e) {
      if (e.target.value === 'active') {
        this.newLanguage.Active = true;
      } else {
        this.newLanguage.Active = false;
      }
    },
    editChangeActive(e) {
      if (e.target.value === 'active') {
        this.selectedLanguage.Active = true;
      } else {
        this.selectedLanguage.Active = false;
      }
    },
    validate(type) {
      setTimeout(() => {
        this.invalidField = null;
      }, 1590);

      if (type === 'edit') {
        this.selectedLanguage.ISO6392.length > 2 &&
        this.selectedLanguage.Country.length > 3
          ? this.editLanguage()
          : this.selectedLanguage.Country.length < 4
            ? (this.invalidField = 'edit-country-length')
            : (this.invalidField = 'edit-ISO6392');
      }
      if (type === 'create') {
        this.newLanguage.Country.length > 3 &&
        this.newLanguage.ISO6392.length === 3
          ? this.createLanguage()
          : this.newLanguage.Country.length < 4
            ? (this.invalidField = 'create-country-length')
            : (this.invalidField = 'create-ISO6392');
      }
    },
    getLanguages() {
      Api.settings.languageConfiguration
        .getLanguages(
          this.pagination.page,
          this.pagination.ppage,
          this.sortASC ? 'asc' : 'desc',
          this.searchRowLanguage
        )
        .then((res) => {
          if (res.status === 200) {
            this.languages = res.data.Data;
            this.totalItems = res.data.Total;
            this.languageFilter();
          }
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: 'Sorry, something went wrong!',
            type: 'error',
            show: true,
          });
        });
    },
    editLanguage() {
      if (this.selectedLanguage) {
        Api.settings.languageConfiguration
          .editLanguage(this.selectedLanguage)
          .then((res) => {
            if (res.status === 200) {
              this.$root.$emit('notification', {
                message: 'Language is updated!',
                type: 'info',
                show: true,
              });
              this.selectedLanguage = null;
              this.getLanguages();
            }
          })
          .catch((err) => {
            this.$root.$emit('notification', {
              message: 'Sorry, something went wrong!',
              type: 'error',
              show: true,
            });
            this.selectedLanguage = null;
          });
      }
    },
    showLanguageEdition(object) {
      const clonedObject = { ...object };
      this.selectedLanguage = clonedObject;
    },
    createLanguage() {
      if (this.newLanguage) {
        Api.settings.languageConfiguration
          .createLanguage(this.newLanguage)
          .then((res) => {
            if (res.status === 200) {
              this.$root.$emit('notification', {
                message: 'language is created',
                type: 'info',
                show: true,
              });
              this.newLanguage = null;
              this.getLanguages();
            }
          })
          .catch((err) => {
            this.$root.$emit('notification', {
              message: 'Sorry, something went wrong!',
              type: 'error',
              show: true,
            });
            this.newLanguage = null;
          });
      }
    },
    confirmRemoveLanguage(id) {
      this.confirmLanguage = id;
    },
    restoreLanguage(id) {
      if (id !== null || undefined) {
        Api.settings.languageConfiguration
          .restoreLanguage(id)
          .then((res) => {
            if (res.status === 200 || res.status === 204) {
              this.$root.$emit('notification', {
                message: 'language is restored',
                type: 'info',
                show: true,
              });
              this.confirmLanguage = null;
              this.getLanguages();
            }
          })
          .catch((err) => {
            this.$root.$emit('notification', {
              message: 'Sorry, something went wrong!',
              type: 'error',
              show: true,
            });
          });
      }
    },
    removeLanguage() {
      if (this.confirmLanguage) {
        Api.settings.languageConfiguration
          .removeLanguage(this.confirmLanguage)
          .then((res) => {
            if (res.status === 200 || res.status === 204) {
              this.$root.$emit('notification', {
                message: 'language is removed',
                type: 'info',
                show: true,
              });
              this.confirmLanguage = null;
              this.getLanguages();
            }
          })
          .catch((err) => {
            this.$root.$emit('notification', {
              message: 'Sorry, something went wrong!',
              type: 'error',
              show: true,
            });
          });
      }
    },
    toggleSortLanguages() {
      this.sortASC = !this.sortASC;
      this.searchRowLanguage = '';
      this.getLanguages();
    },
    languageFilter() {
      if (this.searchRowLanguage === '') {
        this.filteredLanguages = this.languages;
        return;
      }
      searchDebouncer(() => {
        this.getLanguages();
        this.filteredLanguages = this.languages;
      }, 500);
    },
  },
  created() {
    this.getLanguages();
  },
});
</script>

<style lang="scss">
.languages-list {
  .default-table__btn--wraper {
    display: flex;
    justify-content: space-between;
    padding-right: 12px;
    padding: 12px 0;

    button {
      width: 89px;
    }
  }
}

.languages-list__search-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn.btn-submit-edit-language {
  background-color: rgb(151, 151, 151);
  color: #fff;
  &:hover {
    background-color: #0075b1;
    color: #fff;
  }
}

.w250 {
  width: 250px;
}

.w150 {
  width: 250px;
}

.mg-bt52 {
  margin-bottom: 52px;
}

.minw250 {
  min-width: 250px;
}

.language-change-form {
  display: flex;
  flex-direction: column;
  width: max-content;
  height: max-content;
  padding: 21px;

  h2 {
    margin-bottom: 52px;
  }

  &__grid {
    display: grid;
    grid-template-columns: 200px 300px;
    row-gap: 31px;

    &--col1 {
      grid-column: 1;
      display: flex;
      align-items: flex-start;
    }

    input {
      background: #f1f1f1;
      border: none;
      padding: 8px 18px;
      font-size: 16px;
      border-radius: 4px;
      width: 100%;
    }

    textarea {
      background: #f1f1f1;
      border: none;
      padding: 8px 18px;
      font-size: 16px;
      border-radius: 4px;
      width: 100%;
      height: 125px;
    }

    select {
      outline: none;
      min-height: 39px;
      width: 50%;
      font-size: 16px;
      padding-left: 11px;
      cursor: pointer;
      background: #f1f1f1;

      option {
        padding: 11px;
      }
    }
  }

  &__name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 32%;
    margin-bottom: 28px;
  }

  &__buttons {
    display: flex;
    width: 32%;
    justify-content: space-between;
    margin-top: 32px;

    button {
      width: 71px;
    }
  }

  .color-red {
    position: absolute;
    color: red;
    font-size: 12px;
    font-size: 10px;
  }

  .btn-change-lang {
    background: rgb(131, 131, 131);
    color: #fff;
  }

  .toggler {
    padding-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 32%;

    .switch {
      position: relative;
      display: inline-block;
      width: 39px;
      height: 23px;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    input:checked + .slider {
      background-color: #070707;
    }

    input:focus + .slider {
      box-shadow: 0 0 1px #070707;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(15px);
      -ms-transform: translateX(15px);
      transform: translateX(15px);
    }

    /* Rounded sliders */
    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }
}

.language-combinatioin-preloader {
  position: absolute;
  top: 0;
  left: 0;
}

.sort-arrow {
  position: absolute;
  font-size: 25px;
  padding: 0 5px;
  margin-top: -5px;
}

.language-active {
  padding: 7px;
  font-size: 12px;
  &--true {
    border-radius: 5px;
    background-color: rgba(22, 95, 22, 0.555);
    color: #fff;
    animation: flash 2s infinite;
  }
  &--false {
    border-radius: 5px;
    background-color: rgba(136, 136, 136, 0.119);
    color: #fff;
  }
}

.language-deleted {
  padding: 7px;
  font-size: 12px;
  white-space: nowrap;
  &--true {
    border-radius: 5px;
    background-color: rgba(139, 27, 23, 0.555);
    color: #fff;
  }
  &--false {
    border-radius: 5px;
    background-color: rgba(22, 95, 22, 0.255);
    color: #fff;
  }
}

.btn-togglelanguage-active {
  padding: 9px;
  background: grey;
  color: #fff;
  &:hover {
    background-color: #0075b1;
    color: #fff;
  }
}

.toggle-language {
  &-active {
    color: rgb(3, 78, 3);
  }
  &-not-active {
    color: rgb(63, 63, 63);
  }
}

@keyframes flash {
  0% {
    opacity: 1;
    color: #fff;
  }
  50% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
    color: #fff;
  }
}
</style>
